import m from "../../geodata/es2015/svalbardLow";
window.am4geodata_svalbardLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/svalbardLow.js
// module id = null
// module chunks = 